export default function Logo({ className = "w-5 h-5" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M5 4h8a6 6 0 0 1 0 12H9v4H5V4Zm4 4v4h4a2 2 0 1 0 0-4H9Z"
        fill="currentColor"
      />
      <circle cx="17.5" cy="18" r="1.5" fill="currentColor" />
    </svg>
  );
}
